import { computed, reactive } from "vue";

export function usePagination(fetchCallback) {
  const pagination = reactive({
    current_page: 1,
    last_page: 1,
    per_page: 20,
    total: 0,
    from: 0,
    to: 0,
  });

  const visiblePages = computed(() => {
    const pages = [];
    const maxVisible = 5;
    let start = Math.max(
      1,
      pagination.current_page - Math.floor(maxVisible / 2),
    );
    let end = Math.min(pagination.last_page, start + maxVisible - 1);

    if (end - start < maxVisible - 1) {
      start = Math.max(1, end - maxVisible + 1);
    }

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    return pages;
  });

  const changePage = (page) => {
    if (page < 1 || page > pagination.last_page) return;
    pagination.current_page = page;
    fetchCallback();
  };

  const updatePagination = (meta)=>{
    Object.assign(pagination, meta);
  }

  return{
    pagination,
    visiblePages,
    changePage,
    updatePagination
  };

}
